export default __webpack_public_path__ + "static/media/Belt of Red Ruin.9eb54721.jpg";